import { pickBy, identity } from 'ramda';

import { defaultTransformationParams as defaults } from './default-transformation-params';

/**
 * The CloudinaryImage component has a mix of possible ways to specify
 * image transformations.
 *
 * - A "transformation" prop (passed to cloudinary-react Image)
 * - Child <Transformation> components (from cloudinary-react)
 * - A small set of properties that can be passed individually as props to the *   component (a.k.a. "inline" transformation props).
 *
 * This function merges all three sets, following a couple of rules.
 *
 * @param {object} opts
 * @param {object} opts.inline - All possible inline properties that the CloudinaryImage
 * component supports (currently: width, height, crop, dpr). Only keys that have
 * non-falsy values will override default props.
 * @param {object} opts.transformation - The "transformation" param passed to the CloudinaryImage
 * component.  Any keys present in this object will override any "inline" props, even
 * if falsy.
 * @returns {object}
 */
export const mergeTransformationParams = ({
  inline = {},
  transformation = {},
} = {}) => {
  return {
    ...defaults,
    ...pickBy(identity, inline),
    ...transformation,
  };
};
